// export const closeModalAtInit = () => {
//   const closeButton1 = document.querySelector(
//     'div[style*="cursor: pointer"][style*="width: 1rem"]'
//   ) as HTMLElement | null;
//
//   closeButton1?.click();
// };

const waitForElement = <T extends Element>(
  selector: string,
  timeout = 10_000
): Promise<T | null> => {
  return new Promise((resolve) => {
    const existingElement = document.querySelector<T>(selector);

    if (existingElement) {
      resolve(existingElement);
      return;
    }

    const observer = new MutationObserver(() => {
      const element = document.querySelector<T>(selector);

      if (element) {
        observer.disconnect();
        clearTimeout(timeoutId);
        resolve(element);
      }
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
    });

    const timeoutId = window.setTimeout(() => {
      observer.disconnect();
      resolve(null);
    }, timeout);
  });
};

export const closeInitialModal = async () => {
  const svg = await waitForElement<SVGElement>("svg#Layer_1");

  if (!svg) return;

  (svg.parentElement as HTMLElement)?.click();
};
